





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ConversationTopics from '@/components/ConversationTopics/ConversationTopics.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'ConversationTopicSettings',
  	components: { ConversationTopics, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getConversationTopics();
		AgencySettingsModule.getAgencyGroups();
		AgencySettingsModule.getBusinessHours();
		AgencySettingsModule.getBranches();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingConversationTopics;
  	}
}
